import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {userProfile} from '@netx/core-user/collections/singletons/userProfile';

export const isPublicUser = () => {
	return (
		getPublicProperty?.('viewer.userLogin') != null &&
		getPublicProperty?.('viewer.userLogin') === userProfile.get('login')
	);
};

export default isPublicUser;
